import { z } from 'zod';
import { listSearchSchema } from '@/shared/patterns/list-search';
import { billingFilters } from './billing.filters';
export const BILLING_PATH = '/gestao-carteira/cobrancas';
export const billingSearch = listSearchSchema({
  ...billingFilters.shape,
  sheet: z
    .enum([
      'new',
      'register',
      'import',
      'edit',
      'cancel',
      'email',
      'communication',
      'comment',
      'fees',
      'batch',
      'transfer',
      'instruction',
      'delivery',
    ])
    .optional()
    .catch(undefined),
  draft: z.string().optional().catch(undefined),
  selected: z.array(z.string()).optional().catch(undefined),
  edit: z.string().optional().catch(undefined),
});
